// extracted by mini-css-extract-plugin
export default {"dialog":"VpfqSSAaWO_Qe5X","body":"DTL4dLBA_TIjAKv","body-inner":"MndJFc9TsFEGYuB","footer":"ZctJC_Zn3S1aGZC","footer-inner":"SC53o7uvMvXYunc"};